import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Sort = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(2 2)">
        <path d="M16 6.4H3.2a.8.8 0 1 0 0 1.6H16a.8.8 0 1 0 0-1.6z" />
        <path d="M18.4 1.6H.8a.8.8 0 1 0 0 1.6h17.6a.8.8 0 1 0 0-1.6z" />
        <path d="M13.6 11.2h-8a.8.8 0 0 0 0 1.6h8a.8.8 0 0 0 0-1.6z" />
        <path d="M11.2 16H8a.8.8 0 0 0 0 1.6h3.2a.8.8 0 1 0 0-1.6z" />
      </g>
    </svg>
  );
};

Sort.displayName = 'Sort';
